import { createContext, ReactNode, useContext } from "react";
import type { Table as TableType } from "@tanstack/table-core";
import { genericMemo } from "../../../utils";
import { SettingsContextProvider } from "../ControlBar";
import { TableProps } from "../types";

export type TableContextProviderProps<TData extends object, TPredefinedFilter extends unknown = unknown> = {
  children: ReactNode | ReactNode[];
  table?: TableType<TData>
  tableProps?: TableProps<TData, TPredefinedFilter>,
}

export const TableContextProvider = genericMemo(<TData extends object, TPredefinedFilter extends unknown = unknown>({ children, table, tableProps }: TableContextProviderProps<TData, TPredefinedFilter>) => {
  return (
    <TableContext.Provider value={table as unknown as TableType<object> ?? null}>
      <TablePropsContext.Provider value={tableProps as unknown as TableProps<object> ?? null}>
        <SettingsContextProvider>
          {children}
        </SettingsContextProvider>
      </TablePropsContext.Provider>
    </TableContext.Provider>
  );
});

const TableContext = createContext<TableType<object> | null>(null);

export function useTableContext<T extends object>() {
  return (useContext(TableContext) || {}) as TableType<T>;
}

const TablePropsContext = createContext<TableProps<object> | null>(null);

export function useTablePropsContext<T extends object>() {
  return (useContext(TablePropsContext) || {}) as TableProps<T>;
}

